import Modal, { Props } from 'react-modal';
import styled from 'styled-components';
import { TypeAlert } from '.';

type ContentProps = {
  type: TypeAlert;
};

export const Container = styled(Modal).attrs(
  () =>
    ({
      style: {
        content: {
          position: 'relative',
          width: '33.313rem',
          padding: '1rem',
          backgroundColor: 'white',
          outline: 'none',
          borderRadius: 13,
          boxShadow: '0px 3px 6px #00000029',
          marginLeft: '0.5rem',
          marginRight: '0.5rem',
          zIndex: 10,
        },
      },
    } as Props),
)`
  & > button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    z-index: 99999;
    background-color: transparent;
    border: 0;
    padding: 0;
    outline: transparent;
  }
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  z-index: 99999;
  & > div {
    padding-left: 0.75rem;
  }

  & > div p:nth-child(1) {
    color: ${({ theme, type }) => theme.colors[type === 'success' ? 'secondary' : 'error']};
    font-size: 1.375rem;
    font-weight: ${({ type }) => (type === 'success' ? 300 : 450)};
  }

  & > div p:nth-child(2) {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
`;

export const Footer = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;
